import classNames from 'classnames';
import {Dialog} from '@headlessui/react';

export default function Modal({
  show,
  closeModal,
  children,
}: {
  show: boolean;
  closeModal: () => void;
  children: React.ReactNode;
}) {
  return (
    <Dialog
      as="div"
      className={classNames('fixed', 'inset-0', 'z-50', 'overflow-y-auto')}
      open={show}
      onClose={closeModal}
    >
      <div className={classNames('min-h-screen', 'text-center', 'md:px-4')}>
        <Dialog.Overlay
          className={classNames('fixed', 'inset-0', 'bg-black', 'opacity-30')}
        />
        {/* This element is to trick the browser into centering the modal contents. */}
        <span
          className={classNames('inline-block', 'h-screen', 'align-middle')}
          aria-hidden="true"
        >
          &#8203;
        </span>
        {children}
      </div>
    </Dialog>
  );
}
